// components/common/knowledgeLevelStore.ts
"use client";

import { createBrowserStorageStore } from "@/app/shared/hooks/browserStorageStore";

import {
  KNOWLEDGE_LEVEL_STORAGE_KEY,
  type KnowledgeLevel,
  parseKnowledgeLevel,
} from "./knowledgeLevel";

export const knowledgeLevelStore = createBrowserStorageStore<KnowledgeLevel>({
  key: KNOWLEDGE_LEVEL_STORAGE_KEY,
  defaultValue: "beginner",
  parse: (raw) => parseKnowledgeLevel(raw),
  serialize: (value) => value,
});
